// extracted by mini-css-extract-plugin
export default {"heading":"DashboardParent_heading__+OEbE"};